import React, { useEffect, useRef, useState } from "react";
import Navbar from "../common-component/navbar/Navbar";
import "../businesspro/BusinessPro.css";
import topbgbanner from "../../assets/businesspro/topbgbanner.png";
// import topbgbannermobileview from "../../assets/businesspro/topbgbannermobileview.png";
// import bp1 from "../../assets/businesspro/bp1.png";
// import hayat_preview from "../../assets/home-images/alternate-midsection/2.png";
import bp2 from "../../assets/businesspro/bp2.png";
import aibgbanner from "../../assets/businesspro/aibgbanner.png";
import search from '../../assets/home-images/search.png';
import buildmydayicon from "../../assets/businesspro/buildmydayicon.png";
import citymodeicon from "../../assets/businesspro/citymodeicon.png";
import bp3 from "../../assets/businesspro/bp3.png";
import bp4 from "../../assets/businesspro/bp4.png";
// import redx from "../../assets/businesspro/redx.png";
import bgbluebanner from "../../assets/businesspro/bgbluebanner.png";
import bp5 from "../../assets/businesspro/bp5.png";
import bp6 from "../../assets/businesspro/bp6.png";
import bp7 from "../../assets/businesspro/bp7.png";
import bp8 from "../../assets/businesspro/bp8.png";
import bp9 from "../../assets/businesspro/bp9.png";
import bp10 from "../../assets/businesspro/bp10.png";
import bp11 from "../../assets/businesspro/bp11.png";

import journey1 from "../../assets/businesspro/journey1.png";
import journey1mobileview from "../../assets/businesspro/journey1mobileview.png";

import Slider from "react-slick";
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import leftarrow from '../../assets/home-images/right-section-images/leftarrow.png';

// SLIDER 1
import bb1 from "../../assets/businesspro/bb1.png";
import bb2 from "../../assets/businesspro/bb2.png";
import bb3 from "../../assets/businesspro/bb3.png";
import bb4 from "../../assets/businesspro/bb4.png";
import bb5 from "../../assets/businesspro/bb5.png";
import bb6 from "../../assets/businesspro/bb6.png";
import bb7 from "../../assets/businesspro/bb7.png";
import bb8 from "../../assets/businesspro/bb8.png";
import bbicon1 from "../../assets/businesspro/bbicon1.png";
import bbicon2 from "../../assets/businesspro/bbicon2.png";
import bbicon3 from "../../assets/businesspro/bbicon3.png";
import bbicon4 from "../../assets/businesspro/bbicon4.png";
import bbicon5 from "../../assets/businesspro/bbicon5.png";
import bbicon6 from "../../assets/businesspro/bbicon6.png";
import bbicon7 from "../../assets/businesspro/bbicon7.png";
import bbicon8 from "../../assets/businesspro/bbicon8.png";

// SLIDER 2
import bpslide1 from "../../assets/businesspro/bpslide1.png";
import bpslide2 from "../../assets/businesspro/bpslide2.png";
import bpslide3 from "../../assets/businesspro/bpslide3.png";
import bpslide4 from "../../assets/businesspro/bpslide4.png";
import bpslide5 from "../../assets/businesspro/bpslide5.png";
import bpslide6 from "../../assets/businesspro/bpslide6.png";
import bpslide7 from "../../assets/businesspro/bpslide7.png";
import bpslide8 from "../../assets/businesspro/bpslide8.png";

import sliderbluebg from "../../assets/businesspro/sliderbluebg.png";


import bluepartybg from "../../assets/businesspro/bluepartybg.png";


// DOWNLOAD APP SECTION
import banner4_1 from "../../assets/home-images/alternate-midsection/banner4-1.png";
import banner4_2 from "../../assets/home-images/alternate-midsection/banner4-2.png";

import bgbanner4 from "../../assets/home-images/alternate-midsection/bgBanner4.png";
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import qr from '../../assets/home-images/right-section-images/qr.png';

import successtick from "../../assets/businesspro/successtick.png";


import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../common/Common";

const BusinessPro = () => {

    const navigate = useNavigate();

    const navigatetohome = () => {
        navigate("/")
    }
    const formRef = useRef(null);

    const scrollToForm = () => {
        formRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    const BusinessProNextArrow = ({ onClick }) => {
        return (
            <div className="businesspro-arrow businesspro-next-arrow slider1" onClick={onClick}>
                <img src={rightarrow} alt="next" />
            </div>
        );
    };

    const BusinessProPrevArrow = ({ onClick }) => {
        return (
            <div className="businesspro-arrow businesspro-prev-arrow" onClick={onClick}>
                <img src={leftarrow} alt="prev" />
            </div>
        );
    };

    const [slidesToShow, setSlidesToShow] = useState(
        window.innerWidth < 768 ? 3 : 5
    );

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setSlidesToShow(mobile ? 3 : 5);
            setIsMobile(mobile);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const businessprosettings = {
        dots: isMobile,
        arrows: true,
        infinite: false,
        // speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        nextArrow: <BusinessProNextArrow />,
        prevArrow: <BusinessProPrevArrow />,

    };

    const data = [
        {
            title: "Restaurants & cafés",
            img: bb1,
            icon: bbicon1
        },
        {
            title: "Hotels & resorts",
            img: bb2,
            icon: bbicon2
        },
        {
            title: "Wellness, entertainment & retail",
            img: bb3,
            icon: bbicon3
        },
        {
            title: "Clinics, attractions & experiences",
            img: bb4,
            icon: bbicon4
        },
        {
            title: "Destinations & Operators",
            img: bb5,
            icon: bbicon5
        },
        {
            title: "Malls & lifestyle hubs",
            img: bb6,
            icon: bbicon6
        },
        {
            title: "Islands & cultural districts",
            img: bb7,
            icon: bbicon7
        },
        {
            title: "Tourism authorities",
            img: bb8,
            icon: bbicon8
        },

    ];


    // SLIDER 2

    const slides = [bpslide1, bpslide2, bpslide3, bpslide4, bpslide5, bpslide6, bpslide7, bpslide8];

    const [bpslidesToShow, setBpSlidesToShow] = useState(4); // default large desktop

    const updateSlidesToShow = () => {
        const width = window.innerWidth;
        if (width <= 480) {
            setBpSlidesToShow(1.5);
        } else if (width <= 768) {
            setBpSlidesToShow(2);
        } else if (width <= 1440) {
            setBpSlidesToShow(3);
        } else if (width <= 1780) {
            setBpSlidesToShow(4);
        } else {
            setBpSlidesToShow(5);
        }
    };

    useEffect(() => {
        updateSlidesToShow();
        window.addEventListener("resize", updateSlidesToShow);
        return () => window.removeEventListener("resize", updateSlidesToShow);
    }, []);

    const BPNextArrow = ({ onClick }) => {
        return (
            <div className="businesspro-arrow businesspro-next-arrow slider2" onClick={onClick}>
                <img src={rightarrow} alt="next" />
            </div>
        );
    };

    const BPPrevArrow = ({ onClick }) => {
        return (
            <div className="businesspro-arrow businesspro-prev-arrow slider2" onClick={onClick}>
                <img src={leftarrow} alt="prev" />
            </div>
        );
    };

    const bpslidersettings = {
        dots: true,
        infinite: false,
        // speed: 800,
        slidesToShow: bpslidesToShow,
        slidesToScroll: 1,
        centerMode: slidesToShow === 1.5, // for mobile half slide effect
        centerPadding: slidesToShow === 1.5 ? "15px" : "0px",
        nextArrow: <BPNextArrow />,
        prevArrow: <BPPrevArrow />
    };



    const [formData, setFormData] = useState({
        company: "",
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        description: "",
    });
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ""
            });
        }

        // For contact number, only allow digits and limit to 9 characters
        if (name === 'contactNumber') {
            const numericValue = value.replace(/\D/g, ''); // Remove non-digits
            setFormData({
                ...formData,
                [name]: numericValue.slice(0, 9) // Limit to 9 digits
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };
    const fetchContactEnquiry = async () => {
        // Clear previous errors
        setErrors({});

        // Ensure mobile number is 9 digits
        let mobile = formData.contactNumber.replace(/\D/g, ""); // remove non-digits
        if (mobile.length > 9) mobile = mobile.slice(0, 9);

        const payload = {
            company_name: formData.company,
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            mobile_number: mobile,
            message: formData.description,
        };

        try {
            // const response = await axios.post(
            //     "http://localhost:8000/api/website/business-enquiry",
            //     payload
            // );
            const response = await axios.post(`${BACKEND_URL}website/business-enquiry`, payload);

            // Show success popup ONLY on success
            setMessage(response.data.message || "Your enquiry has been submitted successfully!");

            // Push lead form event to Google Tag Manager
            console.log(">>> FORM SUBMITTED SUCCESSFULLY - pushing lead_form_submitted");
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "lead_form_submitted"
            });

            // Google Ads conversion tracking
            if (window.gtag) {
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-17955989620/A1etCPbxhf4bEPTQivJC'
                });
            }

            // Clear form
            setFormData({
                company: "",
                firstName: "",
                lastName: "",
                email: "",
                contactNumber: "",
                description: "",
            });

        } catch (error) {
            console.error("Error saving contact enquiry", error);

            // Handle validation errors from backend
            if (error.response && error.response.data) {
                const backendErrors = error.response.data.errors || {};

                // Map backend error field names to frontend field names
                const mappedErrors = {};

                if (backendErrors.company_name) {
                    mappedErrors.company = backendErrors.company_name[0];
                }
                if (backendErrors.first_name) {
                    mappedErrors.firstName = backendErrors.first_name[0];
                }
                if (backendErrors.last_name) {
                    mappedErrors.lastName = backendErrors.last_name[0];
                }
                if (backendErrors.email) {
                    mappedErrors.email = backendErrors.email[0];
                }
                if (backendErrors.mobile_number) {
                    mappedErrors.contactNumber = backendErrors.mobile_number[0];
                }
                if (backendErrors.message) {
                    mappedErrors.description = backendErrors.message[0];
                }

                setErrors(mappedErrors);
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setErrors({});

        const newErrors = {};

        // Professional email regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (formData.email && !emailRegex.test(formData.email)) {
            newErrors.email = "Please enter a valid email address.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return; // Stop API call
        }

        fetchContactEnquiry();
    };



    return (
        <>
            <Navbar />
            <div className="businesspro-middle-section-container">
                <div
                    className="businesspro-top-banner-backgroundimage"
                    style={{
                        backgroundImage: `url(${topbgbanner})`
                    }}
                >
                    <div className="businesspro-hero-content">
                        <h1 className="businesspro-hero-title">Hayat In</h1>
                        <h2 className="businesspro-hero-tagline">Where Cities Decide. Where Brands Win.</h2>
                        <p className="businesspro-hero-description">
                            One intelligent platform connecting businesses, destinations, and real consumer intent  at the exact moment decisions are made.
                        </p>
                        <div className="businesspro-hero-buttons">
                            <button className="businesspro-btn-demo" onClick={scrollToForm}>Request a Demo</button>
                            <button className="businesspro-btn-works" onClick={navigatetohome}>See How It Works</button>
                        </div>
                    </div>
                </div>

                {/* <div className="businesspro-problem-section">
                    <h2 className="businesspro-problem-title">THE PROBLEM</h2>
                    <p className="businesspro-problem-intro">
                        Cities are loud. Attention is fragmented.<br></br>
                        Brands are everywhere, yet invisible at<br></br>
                        the moment that actually matters.
                    </p>

                </div> */}
                {/* 
                <div className="businesspro-bpimage1-section">
                    <img src={bp1} className="bp-image1" />
                    <div className="businesspro-bpimage1-textcontent">
                        <ul className="businesspro-problem-list">
                            <li>Consumers bounce between apps, social platforms, and search results</li>
                            <li>Brands spend on awareness, not decisions</li>
                            <li>Destinations lack a unified discovery layer</li>
                            <li>Data exists but insight doesn't</li>
                        </ul>
                        <p className="businesspro-problem-summary">
                            Everyone is present. <span className="businesspro-problem-highlight">No one is positioned.</span>
                        </p>
                    </div>
                </div> */}

                <div className="businesspro-bpimage1-section bpimage2-section">
                    <div className="businesspro-bpimage2-textcontent2">
                        {/* <h6>The Solution</h6> */}
                        <p className="bpimage2-para">Hayat In is a city intelligence and discovery platform that places businesses inside real user decisions, not ads.</p>
                        <p className="businesspro-problem-summary">
                            We don't interrupt. <span className="businesspro-problem-highlight">We integrate.</span>
                        </p>
                    </div>
                    <img src={bp11} className="bp-image2" alt="bp11-mg"/>
                </div>

                <div className="businesspro-how-it-works-section">
                    <div className="businesspro-how-it-works-title-wrapper">
                        <div className="businesspro-title-line"></div>
                        <h2 className="businesspro-how-it-works-title">HOW IT WORKS</h2>
                        <div className="businesspro-title-line"></div>
                    </div>
                    <p className="businesspro-how-it-works-subtitle">Simple, Strategic, Scalable</p>
                </div>


                <div className="businesspro-bpimage1-section bpimage3-section">
                    <img src={bp2} className="bp-image3" alt="bp2img" />
                    <div className="businesspro-bpimage3-textcontent2">
                        <p className="businesspro-problem-summary bpimage3-section">
                            Smart <span className="businesspro-problem-highlight">Discovery</span>
                        </p>
                        <p className="bpimage2-para">Users search, explore, or plan their day Hayat In surfaces relevant businesses, offers, and experiences based on context, timing, and intent.</p>

                    </div>
                </div>

                <div
                    className="businesspro-ai-banner-backgroundimage"
                    style={{
                        backgroundImage: `url(${aibgbanner})`
                    }}
                >
                    <div className="businesspro-ai-features-container">
                        <div className="businesspro-ai-feature">
                            <div className="businesspro-ai-feature-icon ai-search-icon">
                                <img src={search} className="businesspro-ai-search" />
                            </div>
                            <h3 className="businesspro-ai-feature-title">AI SEARCH</h3>
                            <p className="businesspro-ai-feature-description">
                                One search. Total discovery. Users search anything, the engine returns: Offers, Events, Posts, Videos, Businesses.
                            </p>
                        </div>

                        <div className="businesspro-ai-feature">
                            <div className="businesspro-ai-feature-icon build-day-icon">
                                <img src={buildmydayicon} className="businesspro-ai-search buildmyday" />
                            </div>
                            <h3 className="businesspro-ai-feature-title">BUILD MY DAY</h3>
                            <p className="businesspro-ai-feature-description">
                                AI itinerary builder Users share time, mood, budget, or group size, and the platform builds custom journeys across venues and experiences.
                            </p>
                        </div>

                        <div className="businesspro-ai-feature">
                            <div className="businesspro-ai-feature-icon city-mood-icon">
                                <img src={citymodeicon} className="businesspro-ai-search" />
                            </div>
                            <h3 className="businesspro-ai-feature-title">CITY MOOD</h3>
                            <p className="businesspro-ai-feature-description">
                                The pulse of the city The app reads behaviour, location, seasonality, time, and movement, and surfaces businesses at the perfect moment.
                            </p>
                        </div>
                    </div>

                </div>

                <div className="businesspro-bpimage1-section bpimage2-section">
                    <div className="businesspro-bpimage2-textcontent2">
                        <h6 style={{ color: "#1877F2" }}>Business Profiles <span style={{ color: "#000" }}>That Actually Perform</span></h6>
                        <p style={{ marginBottom: "0px" }} className="bpimage2-para">Each business gets a living digital presence:</p>
                        <ul className="list-1">
                            <li>Brand profile</li>
                            <li>Followers & engagement</li>
                            <li>Offers & activations</li>
                            <li>Visibility where decisions happen</li>
                        </ul>

                    </div>
                    <img src={bp3} className="bp-image2 mobileview-image3" />
                </div>

                <div style={{ gap: "80px" }} className="businesspro-bpimage1-section bpimage3-section">
                    <img src={bp4} className="bp-image3" />
                    <div className="businesspro-bpimage3-textcontent2">
                        <h6 style={{
                            fontSize: "35px",
                            margin: "0px",
                            fontFamily: "Roboto-SemiBold"
                        }}>Decision-Level Visibility</h6>

                        <p className="bpimage2-para">Your brand appears when users are choosing:</p>
                        <ul className="list-1">
                            <li>Where to eat</li>
                            <li>Where to go</li>
                            <li>What to do</li>
                            <li>What to book</li>
                        </ul>
                        <p style={{
                            fontSize: "25px",
                            fontFamily: "Roboto-Medium"
                        }}
                        >No noise. <span style={{ color: "#1877F2" }}>Just relevance.</span></p>
                    </div>
                </div>

                <div className="businesspro-how-it-works-section">
                    <h5 style={{
                        fontSize: "35px",
                        margin: "0px",
                        fontFamily: "Roboto-SemiBold"
                    }}
                        className="mobile-view-what-makes-haytin-heading"
                    >WHAT MAKES HAYAT IN <span style={{ color: "#F4D03F" }}>DIFFERENT</span> </h5>

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "40px"
                    }}
                        className="mobile-view-redx-content"
                    >
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "20px",
                            fontFamily: "Roboto-Regular"
                        }}
                        ><span></span>Not social media</p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "20px",
                            fontFamily: "Roboto-Regular"
                        }}
                        ><span></span>Not a deals app</p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "20px",
                            fontFamily: "Roboto-Regular"
                        }}
                        ><span></span>Not a directory</p>
                    </div>

                    <h6 style={{
                        fontSize: "25px",
                        margin: "10px 0px 0px 0px",
                        fontFamily: "Roboto-SemiBold"
                    }}
                        className="mobile-view-decision-engine-for-cities"
                    >A decision engine for cities</h6>
                </div>

                <div className="businesspro-center-blue-bg-banner-div">
                    <div
                        className="businesspro-blue-banner-backgroundimage"
                        style={{
                            backgroundImage: `url(${bgbluebanner})`
                        }}
                    >

                        <div className="businesspro-bpimage1-section">
                            <div className="businesspro-bpimage1-textcontent desktop-context-aware-lists mobileview-Context-aware-discovery-lists">
                                <ul className="businesspro-problem-list contextaware">
                                    <li>Context-aware discovery</li>
                                    <li>Real-world intent, not scrolling behavior</li>
                                    <li>City-level structuring (destinations, districts, categories) Built for scale from single outlets to mega destinations</li>
                                    {/* <li>Built for scale — from single outlets to mega destinations</li> */}
                                </ul>
                                <p className="businesspro-problem-summary mobileview-infrastructure-ptag">
                                    <span className="businesspro-problem-highlight">This is infrastructure,</span> not hype.
                                </p>
                            </div>

                            <img style={{ position: "relative", left: "3px" }} src={bp5} className="bp-image1 mobileview-bp-image5" />
                        </div>
                    </div>
                </div>

                <div className="businesspro-how-it-works-section mobileview-who-its-for-section">
                    <h5 style={{
                        fontSize: "35px",
                        margin: "0px",
                        fontFamily: "Roboto-SemiBold"
                    }}
                        className="mobileview-who-its-for-and-businessbrands"
                    >WHO IT’S FOR</h5>


                    <h6 style={{
                        fontSize: "25px",
                        margin: "10px 0px 0px 0px",
                        fontFamily: "Roboto-SemiBold"
                    }}
                        className="mobileview-who-its-for-and-businessbrands"
                    >Businesses & Brands</h6>


                    <div className="businesspro-carousel-container">
                        <Slider {...businessprosettings}>

                            {data.map((item, index) => (
                                <div key={index} className="businesspro-slide-item">
                                    <div
                                        className="bg-card"
                                        style={{ backgroundImage: `url(${item.img})` }}
                                    >
                                        <div className="icon-overlay">
                                            <img src={item.icon} alt="" />
                                        </div>
                                    </div>
                                    <p className="businesspro-carousel-title">{item.title}</p>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    <h6 style={{
                        fontSize: "25px",
                        margin: "10px 0px 0px 0px",
                        fontFamily: "Roboto-SemiBold"
                    }}>If people move through your space Hayat In belongs there.</h6>

                </div>

                <div className="businesspro-bpimage1-section bpimage2-section">
                    <div className="businesspro-bpimage2-textcontent2">
                        <h6>BUSINESS VALUE</h6>
                        <p style={{ marginBottom: "0px" }} className="bpimage2-para">
                            Be discovered at the decision moment
                            Build followers inside a city ecosystem
                            Activate offers without discounting your brand
                            Stay visible beyond paid ads
                            Position once benefit continuously
                            This is long-term digital real estate, not a campaign.
                        </p>


                    </div>
                    <img src={bp6} className="bp-image2 bp-image6" />
                </div>

                <div style={{ gap: "80px" }} className="businesspro-bpimage1-section bpimage3-section">
                    <img src={bp7} className="bp-image3" />
                    <div className="businesspro-bpimage3-textcontent2">
                        <h6 style={{
                            fontSize: "35px",
                            margin: "0px",
                            fontFamily: "Roboto-SemiBold"
                        }}>DATA & INTELLIGENCE</h6>

                        <p className="bpimage2-para">Behind the scenes, Hayat In captures:</p>
                        <ul
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "12px 32px",
                                listStyle: "disc",
                                paddingLeft: "20px",
                            }}
                            className="list-1 mobileview-grid-to-column"
                        >
                            <li>What people search for</li>
                            <li>What they choose</li>
                            <li>Where they go</li>
                            <li>When demand spikes</li>
                        </ul>

                        <p className="bpimage2-para">This unlocks:</p>
                        <ul
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "12px 32px",
                                listStyle: "disc",
                                paddingLeft: "20px",
                            }}
                            className="list-1 mobileview-grid-to-column"
                        >
                            <li>Smarter positioning</li>
                            <li>City-level insights</li>
                            <li>Better offers</li>
                            <li>Future predictive layers</li>
                        </ul>
                    </div>
                </div>


                <div className="businesspro-how-it-works-section designed-around-you-text-content-div">

                    <h5 style={{
                        fontSize: "35px",
                        margin: "0px 0px 20px 0px",
                        fontFamily: "Roboto-SemiBold"
                    }}
                        className="mobileview-designed-around"
                    >Designed Around <span style={{ color: "#F4D03F" }}>You</span></h5>


                    <p style={{
                        fontSize: "20px",
                        margin: "10px 0px 0px 0px",
                        fontFamily: "Roboto-Regular"
                    }}
                        className="mobileview-designed-around"

                    >Hayat In adapts to your preferences and city rhythms, guiding you to follow, engage, and act on what’s truly relevant. Seamless, intuitive, and always personalized to your lifestyle.</p>
                </div>


                <div
                    style={{
                        backgroundImage: `url(${sliderbluebg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        padding: "20px 0", // optional padding for spacing
                    }}
                >
                    <div className="bp-slider-grouping-container">
                        <Slider {...bpslidersettings}>
                            {slides.map((slide, idx) => (
                                <div key={idx}>
                                    <img
                                        className="bp-slide-images"
                                        src={slide}
                                        alt={`slide-${idx}`}

                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>

                </div>

                <div className="party-background-container">
                    <div
                        style={{
                            backgroundImage: `url(${bluepartybg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            height: "220px"
                        }}
                        className="party-bg-image"
                    >
                        <div className="party-container-textcontent">
                            <h6>Enjoy 60% off your first year</h6>
                            <h6>subscription on Hayat In</h6>
                        </div>

                    </div>
                </div>


                <div style={{ padding: "0 80px" }} className="businesspro-bpimage1-section mobileview-bp-image8">

                    <div className="businesspro-bpimage1-textcontent">
                        <p className="businesspro-problem-summary mobileviiew-position-your-summary-ptag">
                            Position your business where customers decide not where they scroll.
                        </p>
                        <h6
                            style={{
                                fontFamily: "Roboto-Bold",
                                fontSize: "30px",
                                margin: "10px 0 0 0",
                            }}
                        >
                            Reach 5,000+ active users in Abu Dhabi
                            <span
                                style={{
                                    display: "block", // makes span behave like a block element
                                    fontFamily: "Roboto-Regular",
                                    fontSize: "20px",
                                    fontWeight: "400"
                                }}
                            >
                                and growing every week.
                            </span>
                        </h6>

                        <button
                            style={{
                                backgroundColor: "#dbe7ff", // light blue background
                                color: "#0b1f5f", // dark blue text
                                padding: "12px 0px",
                                border: "none",
                                borderRadius: "12px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                width: "200px",
                                margin: "20px 0"
                            }}
                        >
                            Claim 60% OFF Now
                        </button>

                        <p style={{
                            fontFamily: "Roboto-Regular",
                            fontSize: "20px",
                            margin: "0"
                        }}>
                            Limited slots · Offer ends soon
                        </p>
                    </div>

                    <img src={bp8} className="bp-image1 bp-image8" />
                </div>


                <div className="mobile-view-business-journey-div business-journey-desktop-view">
                    <div style={{ padding: "0 80px", marginTop: "70px" }} className="mobileview-business-journey">
                        <h6
                            style={{
                                fontFamily: "Roboto-SemiBold",
                                fontSize: "30px",
                                margin: "10px 0 0 0",
                                lineHeight: "1.6"
                            }}
                        >Business Journey</h6>
                        <p
                            style={{
                                fontFamily: "Roboto-Regular",
                                fontSize: "20px",
                                margin: "10px 0 0 0",
                            }}
                        >Be discovered at the decision moment Build followers inside a city ecosystem<br></br>
                            Build followers inside a city ecosystem
                        </p>


                    </div>

                    <div className="business-journey-container">
                        <img src={bp9} id="bp9-img" />
                        <div>
                            <picture>
                                {/* Mobile image */}
                                <source
                                    srcSet={journey1mobileview}
                                    media="(max-width: 768px)"
                                />

                                {/* Default (Desktop) */}
                                <img
                                    src={journey1}
                                    id="journey-img"
                                    alt="Journey"
                                />
                            </picture>
                        </div>

                    </div>
                </div>

                <div
                    style={{
                        backgroundImage: `url(${sliderbluebg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",

                        // height: "420px"
                    }}
                >
                    <div className="slider-blue-banner-text-image-container">
                        <div className="text-content-column-order">
                            <h6>WHY NOW</h6>
                            <p>
                                Cities are going smart.<br></br>
                                Tourism is going data-driven.<br></br>
                                Brands are tired of burning budgets on impressions.<br></br><br></br>

                                The next layer isn’t louder marketing it’s smarter placement.
                            </p>

                            <h6 style={{
                                color: "#1877F2",
                                fontFamily: "Roboto-Medium",
                                fontSize: "25px"
                            }}>That layer is Hayat In.</h6>
                        </div>

                        <img src={bp10} id="bp10-image" />
                    </div>

                </div>


                <div className="ready-to-position-container">
                    <h6>
                        Ready to position your business where decisions happen?
                    </h6>

                    <div className="ready-to-position-buttons">
                        <button className="btn-request-demo" onClick={scrollToForm}>Request a Demo</button>
                        <a href="https://www.hayatinapp.com/vendor/register">
                            <button className="btn-partner-hayat">Partner with Hayat In</button>
                        </a>
                    </div>

                    <p>
                        Hayat In is a UAE-built platform designed to scale across cities, destinations, and markets.
                    </p>
                </div>



                <div className="businesspro-partners-wrapper" ref={formRef}>

                    <div className="businesspro-partner-form-container">
                        <h2 className="partner-form-title">Become a Hayat In BusinessPro Partner</h2>
                        <p className="partner-form-subtitle">Please provide below information and our team will contact you soon.</p>

                        <form className="partner-form" onSubmit={handleSubmit} noValidate>

                            <div className="form-group">
                                <label>Company</label>
                                <input
                                    type="text"
                                    name="company"
                                    placeholder="Company Name"
                                    className={`form-control ${errors.company ? 'error' : ''}`}
                                    value={formData.company}
                                    onChange={handleChange}
                                />
                                {errors.company && <span className="error-message">{errors.company}</span>}
                            </div>

                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label>First Name</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name"
                                        className={`form-control ${errors.firstName ? 'error' : ''}`}
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                    {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                                </div>
                                <div className="form-group half-width">
                                    <label>Last Name</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name"
                                        className={`form-control ${errors.lastName ? 'error' : ''}`}
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                    {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label>Email</label>
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Email"
                                        className={`form-control ${errors.email ? 'error' : ''}`}
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <span className="error-message">{errors.email}</span>}
                                </div>
                                <div className="form-group half-width">
                                    <label>Contact Number</label>
                                    <div className={`phone-input-wrapper ${errors.contactNumber ? 'error' : ''}`}>
                                        <span className="dial-code">+971</span>
                                        <input
                                            type="tel"
                                            name="contactNumber"
                                            placeholder="XXX XXX XXX"
                                            className="form-control phone-input"
                                            value={formData.contactNumber}
                                            onChange={handleChange}
                                            maxLength="9"
                                        />
                                    </div>
                                    {errors.contactNumber && <span className="error-message">{errors.contactNumber}</span>}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    name="description"
                                    placeholder="Description"
                                    className={`form-control ${errors.description ? 'error' : ''}`}
                                    rows="4"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                                {errors.description && <span className="error-message">{errors.description}</span>}
                            </div>

                            {errors.general && (
                                <div className="general-error-message">
                                    {errors.general}
                                </div>
                            )}

                            <div className="form-submit-container">
                                <button type="submit" className="btn-submit-partner">Submit</button>
                            </div>
                        </form>

                        {/* Popup Message - Only shows on SUCCESS */}
                        {message && (
                            <div className="enquiry-success-popup-overlay" onClick={() => setMessage('')}>
                                <div className="enquiry-success-popup-message" onClick={(e) => e.stopPropagation()}>
                                    <div className="enquiry-success-popup-icon">
                                        <img src={successtick} alt="green tick" className="success-tick" />
                                    </div>
                                    <h3 className="enquiry-success-popup-title">Success!</h3>
                                    <p className="enquiry-success-popup-text">{message}</p>
                                    <button
                                        className="enquiry-success-popup-close-btn"
                                        onClick={() => setMessage('')}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>


                <div className="banner4">
                    <div className="banner4-desktop-container" style={{ backgroundImage: `url(${bgbanner4})` }}>
                        <div className="banner4-desktop-download-section">
                            <h3 className="banner4-desktop-download-title">Download Our App</h3>
                            <div className="banner4-desktop-download-content">
                                <div className="banner4-desktop-store-buttons">
                                    <a
                                        href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={app_store} alt="Download on the App Store" />
                                    </a>
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={play_store} alt="Get it on Google Play" />
                                    </a>
                                </div>
                                <div className="banner4-desktop-qr-section">
                                    <img src={qr} alt="QR Code" className="banner4-desktop-qr" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="banner4-mobile">
                        <img src={banner4_1} alt="Banner 2 Part 1" className="banner4-mobile-img" />
                        <div className="banner4-only" style={{ backgroundImage: `url(${banner4_2})` }}>
                            <div className="banner4-download-section">
                                <h3 className="banner4-download-title">Download Our App</h3>
                                <div className="banner4-download-content">
                                    <div className="banner4-store-buttons">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="Download on the App Store" />
                                        </a>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Get it on Google Play" />
                                        </a>
                                    </div>
                                    <div className="banner4-qr-section">
                                        <img src={qr} alt="QR Code" id="banner4-qr" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div >
        </>
    );
}


export default BusinessPro